let _state: Promise<any> | null = null
let _saveRequested: boolean = false

function getAnotherSaveRequested() {
    return _saveRequested
}

function setAnotherSaveRequested(bool: boolean) {
    _saveRequested = bool
}

function getState() {
    return _state
}

function setState(state: Promise<any> | null) {
    _state = state
}

export default {
    getState,
    setState,
    getAnotherSaveRequested,
    setAnotherSaveRequested
}
